import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserEditComponent} from "./user-edit.component";
import {CtDatatableModule, CtModelModule} from "@ctsolution/ct-framework";
import {UserFeeManagerModule} from "../user-fee-manager/user-fee-manager.module";
import { UserInfoWorkDataModule } from '../user-info-work-data/user-info-work-data.module';
import { UserChangePasswordDialogModule } from './user-change-password-dialog/user-change-password-dialog.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { ChangePasswordCardModule } from '../../change-password-card/change-password-card.module';


@NgModule({
  declarations: [UserEditComponent],
  imports: [
    CommonModule,
    CtModelModule,
    CtDatatableModule,
    UserFeeManagerModule,
    UserInfoWorkDataModule,
    UserChangePasswordDialogModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatSnackBarModule,
    ChangePasswordCardModule
  ],
  exports: [UserEditComponent]
})
export class UserEditModule {
}
